export interface ClientItem {
  id: string;
  displayNumber: string;
  name: string;
  category: 'cable' | 'steel' | 'pharma' | 'rubber' | 'oem' | 'other';
  categoryLabel: string;
  lifecycleStage: 1 | 2 | 3 | 4 | 5;
  stageLabel: string;
  logoSrc: string;
  location: string;
  projectNote: string;
  keySpecs?: string[];
}

export const CLIENTS_LIST: ClientItem[] = [
  {
    id: '1',
    displayNumber: '#1',
    name: 'Universal Cables Ltd',
    category: 'cable',
    categoryLabel: 'Wire & Cable',
    lifecycleStage: 2,
    stageLabel: 'Custom Panel Fabrication',
    logoSrc: '/images/clients/1.png',
    location: 'Satna, MP',
    projectNote: 'CCV & PLCV Lines DC to AC Drive Migration with S7-1500 PLC & WinCC SCADA.',
    keySpecs: ['S7-1500 PLC', 'SINAMICS S120 Multi-Axis', 'IP55 Industrial Control Desks', 'Continuous Vulcanization'],
  },
  {
    id: '2',
    displayNumber: '#2',
    name: 'Nexans Cables',
    category: 'cable',
    categoryLabel: 'Wire & Cable',
    lifecycleStage: 1,
    stageLabel: 'Audit & Feasibility',
    logoSrc: '/images/clients/2.png',
    location: 'Qatar / Global',
    projectNote: '30-Ton Unwinder Extrusion Integration with Zero Plant Disruption.',
    keySpecs: ['30-Ton Unwinder Synchronization', 'High-Tension Closed Loop', 'Profinet Fiber Optic Link'],
  },
  {
    id: '3',
    displayNumber: '#3',
    name: 'Bhushan Steel Ltd',
    category: 'steel',
    categoryLabel: 'Iron & Steel',
    lifecycleStage: 3,
    stageLabel: 'Siemens Drive Sync',
    logoSrc: '/images/clients/3.png',
    location: 'Khopoli, MH',
    projectNote: 'Turnkey commissioning of API plant supplied by Mill Tech South Korea.',
    keySpecs: ['G120/S120 PROFIBUS Networking', 'Seam Tracking Automation', 'Heavy Slitting Line Sync'],
  },
  {
    id: '4',
    displayNumber: '#4',
    name: 'Sterlite Technologies',
    category: 'cable',
    categoryLabel: 'Telecom & Fiber',
    lifecycleStage: 1,
    stageLabel: 'Audit & Feasibility',
    logoSrc: '/images/clients/4.png',
    location: 'Silvassa / Global',
    projectNote: 'Fiber Optic Secondary Coating Sync with Sub-Millisecond Speed Control.',
    keySpecs: ['Micro-Tension Control', 'Ultra High-Speed Capstan', 'Laser Diameter Feedback'],
  },
  {
    id: '5',
    displayNumber: '#5',
    name: 'Polycab India Ltd',
    category: 'cable',
    categoryLabel: 'Wire & Cable',
    lifecycleStage: 2,
    stageLabel: 'Custom Panel Fabrication',
    logoSrc: '/images/clients/5.png',
    location: 'Halol, Gujarat',
    projectNote: 'Multi-Axis Capstan Synchronization across continuous high-speed cable extrusion.',
    keySpecs: ['Multi-Capstan Master-Slave Sync', 'IP55 Certified Drive Enclosures', 'Line Speed 800m/min'],
  },
  {
    id: '6',
    displayNumber: '#6',
    name: 'Finolex Cables',
    category: 'cable',
    categoryLabel: 'Wire & Cable',
    lifecycleStage: 5,
    stageLabel: 'Turnkey SLA & Evolution',
    logoSrc: '/images/clients/6.png',
    location: 'Pune / Goa',
    projectNote: 'High-Speed Dual Take-Up Line Control and Continuous Modernization.',
    keySpecs: ['Dual Auto-Bobbin Traversal', 'Constant Tension Winding', '24/7 Breakdown SLA'],
  },
  {
    id: '7',
    displayNumber: '#7',
    name: 'Apar Industries',
    category: 'cable',
    categoryLabel: 'Wire & Cable',
    lifecycleStage: 5,
    stageLabel: 'Turnkey SLA & Evolution',
    logoSrc: '/images/clients/7.png',
    location: 'Khatalwada, Gujarat',
    projectNote: 'Continuous Annealing & Drawing Line Automation with Energy Recovery.',
    keySpecs: ['Annealing Voltage Control', 'Multi-Die Drawing Synchronization', 'Energy Harmonic Filtration'],
  },
  {
    id: '8',
    displayNumber: '#8',
    name: 'KEI Industries Ltd',
    category: 'cable',
    categoryLabel: 'Wire & Cable',
    lifecycleStage: 2,
    stageLabel: 'Custom Panel Fabrication',
    logoSrc: '/images/clients/8.png',
    location: 'Chopanki, Rajasthan',
    projectNote: 'Drum Twister & Armouring Automation with S7-1500 & SINAMICS VFDs.',
    keySpecs: ['Drum Twister Rotation Sync', 'Pitch & Lay Calculation Logic', 'Safety Light Curtain Guarding'],
  },
  {
    id: '9',
    displayNumber: '#9',
    name: 'RPG Cables (KEC Int)',
    category: 'cable',
    categoryLabel: 'Wire & Cable',
    lifecycleStage: 2,
    stageLabel: 'Custom Panel Fabrication',
    logoSrc: '/images/clients/9.png',
    location: 'Thane, MH',
    projectNote: 'Tandem Extrusion Line Retrofit from Obsolete Analog to Digital Profinet.',
    keySpecs: ['Tandem Extruder Master Sync', 'Melt Temperature Multi-Zone PID', 'Custom HMI Recipe Engine'],
  },
  {
    id: '10',
    displayNumber: '#10',
    name: 'Havells India',
    category: 'cable',
    categoryLabel: 'Electrical OEM',
    lifecycleStage: 1,
    stageLabel: 'Audit & Feasibility',
    logoSrc: '/images/clients/10.png',
    location: 'Alwar, Rajasthan',
    projectNote: 'Wire Drawing Machine VFD Integration and Precision Wire Tension Scoping.',
    keySpecs: ['Rod Breakdown Line Sync', 'Dancer Arm Loop Response <5ms', 'High Precision Spooling'],
  },
  {
    id: '11',
    displayNumber: '#11',
    name: 'Cipla Ltd',
    category: 'pharma',
    categoryLabel: 'Pharmaceuticals',
    lifecycleStage: 4,
    stageLabel: 'On-Site Commissioning',
    logoSrc: '/images/clients/11.png',
    location: 'Mumbai / Goa',
    projectNote: '21 CFR Part 11 Granulation, Fluid Bed Dryer (FBD) & Cleanroom SCADA.',
    keySpecs: ['21 CFR Part 11 Electronic Records', 'Audit Trail with Biometric Sign-Off', 'Cleanroom IP65 Desks'],
  },
  {
    id: '12',
    displayNumber: '#12',
    name: 'Sun Pharma',
    category: 'pharma',
    categoryLabel: 'Pharmaceuticals',
    lifecycleStage: 4,
    stageLabel: 'On-Site Commissioning',
    logoSrc: '/images/clients/12.png',
    location: 'Vapi / Baroda',
    projectNote: 'High-Precision Vial & Ampoule Sterile Filling Line Motion Control.',
    keySpecs: ['Peristaltic Dosing Servo Sync', 'Nitrogen Purge Mass Flow Logging', 'Cleanroom Sterile Interlocks'],
  },
  {
    id: '13',
    displayNumber: '#13',
    name: 'Lupin Pharmaceuticals',
    category: 'pharma',
    categoryLabel: 'Pharmaceuticals',
    lifecycleStage: 4,
    stageLabel: 'On-Site Commissioning',
    logoSrc: '/images/clients/13.png',
    location: 'Tarapur, MH',
    projectNote: 'Isolator & Cleanroom Airflow Differential Pressure Cascade Control.',
    keySpecs: ['Cascade Pressure Control Loops', 'HEPA Filter Velocity Feedback', 'Batch SCADA Architecture'],
  },
  {
    id: '14',
    displayNumber: '#14',
    name: 'Aarti Industries',
    category: 'pharma',
    categoryLabel: 'Chemicals & API',
    lifecycleStage: 4,
    stageLabel: 'On-Site Commissioning',
    logoSrc: '/images/clients/14.png',
    location: 'Vapi, Gujarat',
    projectNote: 'MBT Recovery, Distillation Column & Reactor Exothermic Loops.',
    keySpecs: ['Ex-Proof Zone 1 Flameproof Desks', 'Emergency Reactor Quench Logic', 'Hazardous Area Remote I/O'],
  },
  {
    id: '15',
    displayNumber: '#15',
    name: 'Deepak Fertilisers',
    category: 'pharma',
    categoryLabel: 'Chemicals',
    lifecycleStage: 4,
    stageLabel: 'On-Site Commissioning',
    logoSrc: '/images/clients/15.png',
    location: 'Taloja, MH',
    projectNote: 'Chemical Dosing, Corrosive Liquid Volumetric Pumping & Automation.',
    keySpecs: ['Corrosion-Resistant Enclosures', 'Variable Stroke Dosing Control', 'Central SCADA Telemetry'],
  },
  {
    id: '16',
    displayNumber: '#16',
    name: 'CEAT Tyres',
    category: 'rubber',
    categoryLabel: 'Rubber & Tyres',
    lifecycleStage: 5,
    stageLabel: 'Turnkey SLA & Evolution',
    logoSrc: '/images/clients/16.png',
    location: 'Nagpur / Mumbai',
    projectNote: 'Internal Banbury Mixer & 4-Roll Calender Line Multi-Motor Sync.',
    keySpecs: ['High-Torque SINAMICS S120', 'Calender Friction Ratio Calibration', '24/7 Breakdown Hotline'],
  },
  {
    id: '17',
    displayNumber: '#17',
    name: 'MRF Tyres',
    category: 'rubber',
    categoryLabel: 'Rubber & Tyres',
    lifecycleStage: 5,
    stageLabel: 'Turnkey SLA & Evolution',
    logoSrc: '/images/clients/17.png',
    location: 'Chennai / Goa',
    projectNote: 'Hydraulic Vulcanizing Tyre Curing Press Precision Cycle Timers.',
    keySpecs: ['Steam Temperature & Pressure PID', 'Multi-Cavity Press Synchronization', 'Continuous Plant Support'],
  },
  {
    id: '18',
    displayNumber: '#18',
    name: 'BKT Tires',
    category: 'rubber',
    categoryLabel: 'Rubber & Tyres',
    lifecycleStage: 5,
    stageLabel: 'Turnkey SLA & Evolution',
    logoSrc: '/images/clients/18.png',
    location: 'Waluj, Aurangabad',
    projectNote: 'Heavy Off-Highway Tread Extrusion Line Multi-Motor Speed Ratio.',
    keySpecs: ['Heavy Duty Extruder Gear Sync', 'Dual Roller Feed Tension Tuning', 'Annual Maintenance Contract'],
  },
  {
    id: '19',
    displayNumber: '#19',
    name: 'Jindal Steel & Power',
    category: 'steel',
    categoryLabel: 'Iron & Steel',
    lifecycleStage: 3,
    stageLabel: 'Siemens Drive Sync',
    logoSrc: '/images/clients/19.png',
    location: 'Raigarh, CG',
    projectNote: 'Tube Mill & Slitting Line DC to AC Siemens Vector Drive Retrofit.',
    keySpecs: ['Flying Cut-Off Saw Motion Sync', 'S120 Vector Drive Common DC Bus', 'Profinet Fiber Fieldbus'],
  },
  {
    id: '20',
    displayNumber: '#20',
    name: 'Tata Steel Ltd',
    category: 'steel',
    categoryLabel: 'Iron & Steel',
    lifecycleStage: 3,
    stageLabel: 'Siemens Drive Sync',
    logoSrc: '/images/clients/20.png',
    location: 'Jamshedpur / Tarapur',
    projectNote: 'Heavy EOT Crane Material Handling, Ladle Hoist & Anti-Sway Sync.',
    keySpecs: ['Tandem Hoist Speed Sync', 'Anti-Sway Crane Algorithm', 'Heavy Duty IP55 Industrial Panels'],
  },
  {
    id: '21',
    displayNumber: '#21',
    name: 'JSW Steel Ltd',
    category: 'steel',
    categoryLabel: 'Iron & Steel',
    lifecycleStage: 3,
    stageLabel: 'Siemens Drive Sync',
    logoSrc: '/images/clients/21.png',
    location: 'Dolvi, MH',
    projectNote: 'Reheating Furnace Charging, Skid Movement & Temperature Profiling.',
    keySpecs: ['Multi-Zone Burner Combustion PID', 'Walking Beam Hydraulic Motion', 'Redundant S7-1500 PLC'],
  },
  {
    id: '22',
    displayNumber: '#22',
    name: 'Essar Steel (AM/NS)',
    category: 'steel',
    categoryLabel: 'Iron & Steel',
    lifecycleStage: 3,
    stageLabel: 'Siemens Drive Sync',
    logoSrc: '/images/clients/22.png',
    location: 'Hazira, Gujarat',
    projectNote: 'Continuous Multi-Stand Rolling Mill Drive Synchronization.',
    keySpecs: ['Tension & Looper Control System', 'Impact Drop Compensation (<10ms)', 'High-Speed Analog Feedback'],
  },
  {
    id: '23',
    displayNumber: '#23',
    name: 'Godrej & Boyce',
    category: 'oem',
    categoryLabel: 'Discrete OEM',
    lifecycleStage: 1,
    stageLabel: 'Audit & Feasibility',
    logoSrc: '/images/clients/23.png',
    location: 'Vikhroli, Mumbai',
    projectNote: 'Automated Storage & Retrieval Systems (ASRS) & Shuttle Control.',
    keySpecs: ['Multi-Level Shuttle Kinematics', 'Warehouse WMS Interface API', 'Optical Positioning Sensors'],
  },
  {
    id: '24',
    displayNumber: '#24',
    name: 'Larsen & Toubro (L&T)',
    category: 'oem',
    categoryLabel: 'Heavy EPC',
    lifecycleStage: 2,
    stageLabel: 'Custom Panel Fabrication',
    logoSrc: '/images/clients/24.png',
    location: 'Powai / Hazira',
    projectNote: 'Turnkey IP55 Industrial Control Panel Fabrication, Testing & Staged FAT.',
    keySpecs: ['Heavy Industrial Form 4b Enclosures', 'Certified Busbar Short-Circuit Rating', 'Stringent L&T FAT Standards'],
  },
  {
    id: '25',
    displayNumber: '#25',
    name: 'Thermax Ltd',
    category: 'other',
    categoryLabel: 'Energy & Water',
    lifecycleStage: 1,
    stageLabel: 'Audit & Feasibility',
    logoSrc: '/images/clients/25.png',
    location: 'Pune, MH',
    projectNote: 'Industrial Water Treatment & High-Pressure Multi-Pump Cascade Logic.',
    keySpecs: ['Multi-Pump VFD Lead-Lag Cascade', 'Energy Efficient Pressure Staging', 'Remote Telemetry SCADA'],
  },
  {
    id: '26',
    displayNumber: '#26',
    name: 'UPL Limited',
    category: 'pharma',
    categoryLabel: 'Agrochemicals',
    lifecycleStage: 4,
    stageLabel: 'On-Site Commissioning',
    logoSrc: '/images/clients/26.png',
    location: 'Ankleshwar, Gujarat',
    projectNote: 'Continuous Resin Column Automation, pH Neutralization & SCADA Logging.',
    keySpecs: ['Automated Regeneration Sequence', 'Hazardous Area Remote I/O Nodes', 'WinCC Professional Batch Logging'],
  },
  {
    id: '28',
    displayNumber: '#28',
    name: 'Siemens Solution Network',
    category: 'oem',
    categoryLabel: 'Global Partner',
    lifecycleStage: 5,
    stageLabel: 'Turnkey SLA & Evolution',
    logoSrc: '/images/clients/28.png',
    location: 'India & Global',
    projectNote: 'Certified Siemens Solution Partner for Industrial Automation & Drives.',
    keySpecs: ['Siemens Authorized Channel SI', 'Certified SINAMICS & TIA Engineers', 'Direct Global Engineering Support'],
  },
];
